import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { GenericRepository } from "../generic-repository/GenericRepository";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { POSStrings } from "../../models/POSStrings/pos-strings.model";
import { IPOSStringsRepository } from "./IPOSStringsRepository";


@Injectable()
export class POSStringsRepository extends GenericRepository<POSStrings> implements IPOSStringsRepository {
    url: string = environment.urlAddress;
    constructor(protected _http: HttpClient) {
        super(_http, 'api/POSStrings', environment.urlAddress);
    }

    GetAll(currentPage: number, recordsPerPage: number, filterText: string): Observable<any> {
        filterText = filterText.split('/').join('~');
        if (filterText == "") {
            filterText = "|";
        }
        return this._http
            .get(this.url + 'api/POSStrings/SelectAll' + '/' + currentPage + '/' + recordsPerPage + '/' + filterText, this.httpOptions).pipe(map(this.extractData), catchError(this.handleError));
    }

    LoadRec(smartAppStringID: number): Observable<any> {
        return this.GetById('/GetRec/' + smartAppStringID).pipe(map(this.extractData), catchError(this.handleError));
    }

    SaveRec(item: POSStrings): Observable<any> {
        return this.PostData('/SaveRec', item).pipe(map(this.extractData), catchError(this.handleError));
    }     
}
